module.exports = __webpack_public_path__ + "img/amos-bow.6ade1154.webp";